import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";

import { USER_ROLE } from "../system/global-enums";
import { EMPTY_STRING, SCREEN_PATH } from "../constants";
import { UserIcon, ArrowUpIcon, UserFillIcon } from "../assets/icons";
import { authActions } from "../redux/actions";

const UserDropdown = (props) => {
  const {
    role = EMPTY_STRING,
    isNotSubscribed,
    isAgentApproved,
    isPaymentDisabled,
    openPasswordModal = () => {},
  } = props;

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const toggleDropdown = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const closeDropdown = () => {
    setOpen(false);
  };

  const navigateToProfile = () => {
    navigate(
      role === USER_ROLE.AGENT
        ? SCREEN_PATH.AGENT_PROFILE
        : SCREEN_PATH.MY_PROFILE
    );
  };

  const getSubscriptionLinkPath = () => {
    if (isNotSubscribed) {
      return role === USER_ROLE.USER
        ? SCREEN_PATH.SUBSCRIPTION_PLANS
        : SCREEN_PATH.AGENT_SUBSCRIPTION_PLANS;
    }

    return role === USER_ROLE.USER
      ? SCREEN_PATH.MY_SUBSCRIPTIONS
      : SCREEN_PATH.AGENT_MY_SUBSCRIPTIONS;
  };

  const navigateToSubscriptions = () => {
    navigate(getSubscriptionLinkPath());
  };

  const handleResize = useCallback(() => {
    setWindowWidth(window.innerWidth);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, [handleResize]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const dropdownContainer = document.querySelector(".dropdown-container");
      if (dropdownContainer && !dropdownContainer.contains(event.target)) {
        closeDropdown();
      }
    };

    if (open) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    return () => document.removeEventListener("click", handleOutsideClick);

    // eslint-disable-next-line
  }, [open]);

  return (
    <>
      {windowWidth < 992 && role !== USER_ROLE.ADMIN ? (
        <>
          <Nav.Link
            as={NavLink}
            to={
              role === USER_ROLE.AGENT
                ? SCREEN_PATH.AGENT_PROFILE
                : SCREEN_PATH.MY_PROFILE
            }
            className="nav-item mx-lg-3 px-lg-2 p-0 mb-2 mb-lg-0"
          >
            My Profile
          </Nav.Link>
          {role === USER_ROLE.AGENT &&
          (!isAgentApproved || isPaymentDisabled) ? null : (
            <Nav.Link
              as={NavLink}
              to={getSubscriptionLinkPath()}
              className="nav-item mx-lg-3 px-lg-2 p-0 mb-2 mb-lg-0"
            >
              Subscriptions
            </Nav.Link>
          )}
          <Nav.Item
            onClick={() => authActions.logout()}
            className="nav-item mx-lg-3 px-lg-2 p-0 mb-2 mb-lg-0"
          >
            Logout
          </Nav.Item>
        </>
      ) : (
        <div className={`dropdown-container ${open ? "open" : ""}`}>
          <div className="dropdown-trigger" onClick={toggleDropdown}>
            {open ? (
              <>
                <img
                  src={UserFillIcon}
                  alt="user"
                  className="position-relative"
                />
                <img
                  src={ArrowUpIcon}
                  alt="arrow up"
                  className="position-absolute top-100 start-50 translate-middle mt-1"
                />
              </>
            ) : (
              <img src={UserIcon} alt="user" className="position-relative" />
            )}
          </div>
          <div className="dropdown-menu">
            <ul>
              {role === USER_ROLE.USER || role === USER_ROLE.AGENT ? (
                <>
                  <li onClick={navigateToProfile}>My Profile</li>
                  {role === USER_ROLE.AGENT &&
                  (!isAgentApproved || isPaymentDisabled) ? null : (
                    <li onClick={navigateToSubscriptions}>Subscriptions</li>
                  )}
                </>
              ) : (
                <li onClick={openPasswordModal}>Change Password</li>
              )}
              <li onClick={() => authActions.logout()}>Logout</li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default UserDropdown;
